var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 253",
    style: {
      enableBackground: "new 0 0 1600 253"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CC6237;}\r\n\t.st1{fill:#211A13;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.97,166.06l28.41-10.89V81.69L242.97,70.8C224.76,30.23,184.04,1.96,136.69,1.96S48.62,30.23,30.41,70.8 L2,81.69v73.47l28.41,10.89c6.67,14.86,16.37,28.06,28.3,38.84v7.84H37.56l-13.97,41.79h226.2l-13.97-41.79H214v-7.23 C226.24,194.62,236.17,181.19,242.97,166.06z M105.65,37.52h62.08v15.61h-62.08V37.52z M206.87,158.02l-21.42,21.42H87.43 l-21.59-21.59V87.9l21.56-21.56h98.38l21.08,21.08V158.02z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M798.26,80.41c-47.58,0-86.3,38.71-86.3,86.3c0,47.58,38.71,86.3,86.3,86.3s86.3-38.71,86.3-86.3 C884.55,119.12,845.84,80.41,798.26,80.41z M811.83,166.28c0.23,7.49-5.67,13.77-13.16,14c-4.9,0.18-8.19-2.24-9.72-3.68 c-1.53-1.44-4.12-4.58-4.27-9.48c-0.23-7.49,5.67-13.77,13.16-14c0.14,0,0.28-0.01,0.43-0.01 C805.56,153.12,811.61,158.94,811.83,166.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "370.83,147.39 397.89,147.39 397.89,252.02 463.88,252.02 463.88,147.39 490.94,147.39 490.94,81.39  370.83,81.39  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M902.25,82.28v169.73h64.7v-22.64h67.85l30.65-30.64v-84.74l-31.72-31.71H902.25z M1000.74,164.67h-33.79 v-17.68h33.79V164.67z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "511.31,252 576.01,252 576.01,146.13 625.53,146.13 592.59,179.07 592.59,252 693.58,252  693.58,187.3 675.87,187.3 694.26,168.9 694.26,81.42 511.31,81.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1085.14,82.28 1085.14,252.02 1149.85,252.02 1149.85,146.98 1167.39,146.98 1167.39,252.02  1232.09,252.02 1232.09,82.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1302.3,71.29h0.08v0.07h-0.08V71.29z M1302.3,116.35h17.28c5.16-0.05,8.98,1.08,11.46,3.38 c2.48,2.3,4,4.91,4.58,7.81c0.58,2.9,0.86,6.23,0.86,9.99v55.21c0,3.76-0.29,7.07-0.86,9.95c-0.58,2.88-2.1,5.47-4.58,7.77 c-2.48,2.31-6.27,3.46-11.38,3.46h-17.35V116.35z M1321.08,197.81c0.4-0.43,0.66-1.1,0.79-2.03c0.12-0.93,0.19-2.32,0.19-4.17 v-52.73c0-1.85-0.08-3.28-0.23-4.28c-0.15-1-0.43-1.71-0.83-2.14c-0.4-0.43-1.03-0.64-1.88-0.64h-2.4v66.62h2.48 C1320.05,198.45,1320.68,198.23,1321.08,197.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1353.75,116.35h14.95v97.57h-14.95V116.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1389.76,209.22c-2.53-3.73-3.79-9-3.79-15.81v-56.93c0-3.76,0.29-7.07,0.86-9.95 c0.58-2.88,2.1-5.47,4.58-7.77c2.48-2.3,6.27-3.45,11.38-3.45h1.35c6.41,0,10.79,1.69,13.14,5.07c2.35,3.38,3.58,7.7,3.68,12.96 v18.48h-14.42v-17.88c0-1.05-0.29-1.84-0.86-2.37c-0.58-0.53-1.24-0.79-1.99-0.79h-0.45c-0.8,0-1.4,0.21-1.8,0.64 c-0.4,0.43-0.67,1.11-0.79,2.07c-0.13,0.95-0.19,2.35-0.19,4.21v53.78c0,2.9,0.17,4.93,0.52,6.08c0.35,1.15,1.08,1.76,2.18,1.8 h0.45c1.05-0.05,1.8-0.36,2.25-0.94c0.45-0.58,0.68-1.44,0.68-2.59v-23.81h-3.53v-12.55h18.03v54.38h-9.69v-7.29h-0.68 c-0.05,0.95-0.15,1.78-0.3,2.48c-0.3,1.9-1.28,3.34-2.93,4.32c-1.65,0.98-3.63,1.46-5.93,1.46h-0.98 C1395.89,214.82,1392.29,212.95,1389.76,209.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1439.07,116.35h14.95v97.57h-14.95V116.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1480.46,131.82h-9.16v-15.47h32.9v15.47h-9.16v82.09h-14.57V131.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1524.32,116.35h19.9l10.74,97.57h-14.72l-2.03-20.13h-7.89l-2.18,20.13h-14.57L1524.32,116.35z  M1532.81,179.67h2.93c0.35,0,0.65,0.03,0.9,0.08l0.23,0.08l0.22-0.15l-0.15-0.45c0-0.35-0.03-0.68-0.08-0.98l-2.1-32 c-0.05-1.05-0.1-2.28-0.15-3.68c-0.05-1.4-0.08-2.58-0.08-3.53h-0.6c0,0.95-0.03,2.13-0.08,3.53c-0.05,1.4-0.1,2.63-0.15,3.68 l-1.95,32l-0.08,0.45l-0.07,0.53l-0.15,0.45l0.22,0.15l0.3-0.08C1532.23,179.69,1532.51,179.67,1532.81,179.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1570.73,116.35h15.25v82.1H1598v15.47h-27.27V116.35z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1302.3,
    y: 81.81,
    className: "st0",
    width: 295.7,
    height: 14.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.3,
    y: 236.68,
    className: "st0",
    width: 295.7,
    height: 14.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlt);
export default __webpack_public_path__ + "static/media/logo-alt.47f32db2129ff72e37b057e7697403c8.svg";
export { ForwardRef as ReactComponent };